<div #mainDiv_ll_model_cash_rule_edit style="display: flex;">
  <div [style.top.px]="30"
       [style.left.px]="0"
       style="position: absolute; background-color: transparent; border: none; outline: none;">

    <!-- Unsaved Changes Label -->
    <div [hidden]="!bundle.isDirty" class="txtBold_12" style="color: red; padding-bottom: 5px;">
      Unsaved Changes
    </div>

    <!-- Payer ID -->
    <div style="clear: left; padding-top: 0px;">
      <div class="txtBold_12" [style.width.px]="150" style="float: left;">
        Bank Name:
      </div>
      <div class="txtNorm12" style="float: left; padding-left: 5px;">
        {{bundle.SENDERNAME}}
      </div>
    </div>

    <!-- Rule In/Out -->
    <div style="clear: left; padding-top: 5px;">
      <div class="txtBold_12" [style.width.px]="150" style="float: left;">
        Rule In/Out:
      </div>
      <div style="float: left; padding-left: 0px;">
        <div *ngFor="let ac_eligible of bundle.eligibleChoices" style="float: left; font-size: 13px; font-family: Arial; padding-right: 10px;">
          <label>
            <input type="radio"
                   name="eligiblegroup"
                   [value]="ac_eligible.code"
                   [checked]="ac_eligible.SELECTED"
                   (change)="selectAgeCap($event, 'PAYERELIGIBLEYN')">
            {{ac_eligible.LOGICRESULTINOROUT}}
          </label>
        </div>
      </div>
    </div>

    <!-- Transaction Details (Div-based + Strong Selection Fix) -->
    <div *ngIf="bundle.transaction && bundle.transaction.SENDERNAME"
         [style.width.px]="bundle.tableW"
         style="clear: left; padding-top: 10px; overflow-x: auto; border: 1px solid #ccc;">

      <!-- Header Row -->
      <div style="display: flex; min-width: 1165px; background-color: #f0f0f0; font-family: Arial; font-size: 12px; font-weight: bold; border-bottom: 1px solid #ccc; user-select: none;">
        <div style="width: 70px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Bank</div>
        <div style="width: 100px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Location</div>
        <div style="width: 75px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Location ID</div>
        <div style="width: 100px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Date</div>
        <div style="width: 70px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Type</div>
        <div style="width: 100px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Amount</div>
        <div style="width: 50px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Code</div>
        <div style="width: 100px; padding: 5px; text-align: left; border-right: 1px solid #ccc;">Description</div>
        <div style="flex: 1; padding: 5px; text-align: left; min-width: 500px;">Detail</div>
      </div>

      <!-- Data Row - Strong Selection Enabled -->
      <div style="display: flex; min-width: 1165px; font-family: Arial; font-size: 12px; background-color: white;">

        <div style="width: 70px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.SENDERNAME}}">
          {{bundle.transaction.SENDERNAME}}
        </div>

        <div style="width: 100px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.RECIPIANTNAME}}">
          {{bundle.transaction.RECIPIANTNAME}}
        </div>

        <div style="width: 75px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.RECIPIANTIDNUMBER}}">
          {{bundle.transaction.RECIPIANTIDNUMBER}}
        </div>

        <div style="width: 100px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.ENTRYDATE_TXT}}">
          {{bundle.transaction.ENTRYDATE_TXT}}
        </div>

        <div style="width: 70px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.ENTRYTYPE}}">
          {{bundle.transaction.ENTRYTYPE}}
        </div>

        <div style="width: 100px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.ENTRYAMOUNT}}">
          {{bundle.transaction.ENTRYAMOUNT}}
        </div>

        <div style="width: 50px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.ENTRYCODE}}">
          {{bundle.transaction.ENTRYCODE}}
        </div>

        <div style="width: 100px; padding: 5px; border-right: 1px solid #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.ENTRYDESCRIPTION}}">
          {{bundle.transaction.ENTRYDESCRIPTION}}
        </div>

        <div style="flex: 1; padding: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 500px;
                -webkit-user-select: text !important; -moz-user-select: text !important; -ms-user-select: text !important; user-select: text !important; cursor: text;"
             title="{{bundle.transaction.ENTRYDETAIL}}">
          {{bundle.transaction.ENTRYDETAIL}}
        </div>
      </div>
    </div>

    <!-- Rules Table -->
    <div [style.width.px]="bundle.tableW" style="clear: left; padding-top: 10px; overflow-x: auto;">
      <table style="border-collapse: collapse; table-layout: fixed;" [style.width.px]="bundle.tableW">
        <thead>
          <tr style="background-color: #f0f0f0;">
            <th [style.width.px]="bundle.tableW / 3" style="padding: 5px; text-align: left; font-family: Arial; font-size: 12px; font-weight: bold; border: 1px solid #ccc;">Rule Column</th>
            <th [style.width.px]="bundle.tableW / 3" style="padding: 5px; text-align: left; font-family: Arial; font-size: 12px; font-weight: bold; border: 1px solid #ccc;">Qualifier</th>
            <th [style.width.px]="bundle.tableW / 3" style="padding: 5px; text-align: left; font-family: Arial; font-size: 12px; font-weight: bold; border: 1px solid #ccc;">Rule Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rule of bundle.rules">
            <td style="padding: 5px; font-family: Arial; font-size: 12px; border: 1px solid #ccc;">
              <select [(ngModel)]="rule.TARGETCOLUMN" (ngModelChange)="onRuleChange()" style="width: 100%; height: 20px;">
                <option value=""></option>
                <option value="SENDERNAME">Bank</option>
                <option value="RECIPIANTNAME">Location</option>
                <option value="RECIPIANTIDNUMBER">Location ID</option>
                <option value="ENTRYDATE_TXT">Date</option>
                <option value="ENTRYTYPE">Type</option>
                <option value="ENTRYAMOUNT">Amount</option>
                <option value="ENTRYCODE">Code</option>
                <option value="ENTRYDESCRIPTION">Description</option>
                <option value="ENTRYDETAIL">Detail</option>
              </select>
            </td>
            <td style="padding: 5px; font-family: Arial; font-size: 12px; border: 1px solid #ccc;">
              <select [(ngModel)]="rule.QUALIFIER" (ngModelChange)="onRuleChange()" style="width: 100%; height: 20px;">
                <option value=""></option>
                <option value="Equals">Equals</option>
                <option value="Contains">Contains</option>
              </select>
            </td>
            <td style="padding: 5px; font-family: Arial; font-size: 12px; border: 1px solid #ccc;">
              <input type="text" [(ngModel)]="rule.TARGETVALUE" (ngModelChange)="onRuleChange()" style="width: 100%; height: 20px;">
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Save Button (Left) + Message (to the right of button) -->
    <div style="clear: left; padding-top: 10px; display: flex; align-items: center; gap: 15px;">
      <div class="wordBtnGroup">
        <div class="wordBtn16" (click)="saveRules()">Save Rule</div>
      </div>

      <!-- Inline Message -->
      <div *ngIf="saveMessage"
           [style.color]="saveMessageType === 'error' ? 'red' : 'green'"
           style="font-family: Arial; font-size: 13px; font-weight: 500;">
        {{ saveMessage }}
      </div>
    </div>

  </div>
</div>
